import React, { useEffect } from "react";
import "../assets/custom-scss/landing.scss"
import Header from "./landingsections/Header";
import FloatIcons from "./landingsections/FloatIcons";
import HeroSection from "./landingsections/HeroSection";
import FeatureSection from "./landingsections/FeatureSection";
import AboutSection from "./landingsections/AboutSection";
import CompareSection from "./landingsections/CompareSection";
import ModulesSection from "./landingsections/ModulesSection";
import HMSBenefits from "./landingsections/HMSBenefits";
import CTASection from "./landingsections/CTASection";
import HMSTestimonials from "./landingsections/HMSTestimonials";
import Footer from "./landingsections/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
const LandingPage = () => {


    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    return (
        <div className="page-wrapper">

            <Header />
            <HeroSection />
            <FeatureSection />
            <AboutSection />
            <CompareSection />
            <ModulesSection />
            <HMSBenefits />
            <CTASection />
            <HMSTestimonials />
            <FloatIcons />
            <Footer />

        </div>
    );
};

export default LandingPage;